import clsx from 'clsx'

import { Skeleton } from './Skeleton'

export type PageFilterChipsSkeletonProps = {
  className?: string
  count?: number
}

export const PageFilterChipsSkeleton = ({
  className,
  count = 4
}: PageFilterChipsSkeletonProps) => (
  <div className={clsx('flex gap-2 overflow-hidden', className)} aria-hidden>
    {Array.from({ length: count }).map((_, index) => (
      <Skeleton key={index} variant="pill" className="h-8 w-[4.5rem] shrink-0" />
    ))}
  </div>
)
